import { IGenericAnalysisAlloc } from "../../../omnia";
import { IAnalysisLayerData } from "../map/analysis-layer";
import { GlobalAnalysisVM } from "./analysis-vm";

export abstract class GlobalAnalysisAlloc {

    public allocation: IGenericAnalysisAlloc;
    public analysis: GlobalAnalysisVM;
    public layerData: IAnalysisLayerData;
    public shown: boolean;

    abstract getDescription(): string;
    abstract getId(): any;
}
